import React from "react";
import { Field, ErrorMessage } from "formik";

const FormikStyledField = ({ label, name, type, required, placeholder, tooltip, translatedErrorMessage }) => {
	return (
		<Field name={name}>
			{({ field, meta }) => (
				<div className="uppercase text-sm flex gap-2 flex-col relative">
					{/* Label + tooltip */}
					<div className="flex justify-between items-center">
						<label htmlFor={name} className="flex items-center gap-1 uppercase text-neutral-50 text-sm">
							{label}
							{required && (
								<span className="text-ipxon-magenta flex gap-0.5 text-[10px] font-bold uppercase">
									*
									<div
										className={`animate-pulse ${
											meta.touched && meta.error ? "opacity-100 fade-in" : "opacity-0 fade-out"
										} transition-opacity duration-500`}
									>
										{meta.touched && meta.error ? (
											translatedErrorMessage ? (
												<span>{translatedErrorMessage}</span>
											) : (
												<ErrorMessage name={name} />
											)
										) : null}{" "}
									</div>
								</span>
							)}
						</label>

						{/* Tooltip Icon */}
						{tooltip && (
							<div className="relative group cursor-pointer">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="15"
									height="15"
									viewBox="0 0 15 15"
									fill="none"
									className="transition-transform duration-200"
								>
									<path
										d="M7.5 1.07143C4.18629 1.07143 1.07143 4.18629 1.07143 7.5C1.07143 10.8137 4.18629 13.9286 7.5 13.9286C10.8137 13.9286 13.9286 10.8137 13.9286 7.5C13.9286 4.18629 10.8137 1.07143 7.5 1.07143ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
										fill="#FAFAFA"
									/>
									<path
										d="M7.5 6C7.91421 6 8.25 6.33579 8.25 6.75V11.25C8.25 11.6642 7.91421 12 7.5 12C7.08579 12 6.75 11.6642 6.75 11.25V6.75C6.75 6.33579 7.08579 6 7.5 6Z"
										fill="#FAFAFA"
									/>
									<path
										d="M8.625 4.125C8.625 4.74632 8.12132 5.25 7.5 5.25C6.87868 5.25 6.375 4.74632 6.375 4.125C6.375 3.50368 6.87868 3 7.5 3C8.12132 3 8.625 3.50368 8.625 4.125Z"
										fill="#FAFAFA"
									/>
								</svg>

								{/* Tooltip bubble */}
								<div className="absolute flex items-center gap-4 py-4 px-3 bg-[#27272a] border-[#6a6a72] right-0 top-6 border normal-case z-10 w-max max-w-xs rounded-md text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 15 15"
										fill="none"
										className="transition-transform duration-200 group-hover:scale-110"
									>
										<path
											d="M7.5 1.07143C4.18629 1.07143 1.07143 4.18629 1.07143 7.5C1.07143 10.8137 4.18629 13.9286 7.5 13.9286C10.8137 13.9286 13.9286 10.8137 13.9286 7.5C13.9286 4.18629 10.8137 1.07143 7.5 1.07143ZM0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
											fill="#FAFAFA"
										/>
										<path
											d="M7.5 6C7.91421 6 8.25 6.33579 8.25 6.75V11.25C8.25 11.6642 7.91421 12 7.5 12C7.08579 12 6.75 11.6642 6.75 11.25V6.75C6.75 6.33579 7.08579 6 7.5 6Z"
											fill="#FAFAFA"
										/>
										<path
											d="M8.625 4.125C8.625 4.74632 8.12132 5.25 7.5 5.25C6.87868 5.25 6.375 4.74632 6.375 4.125C6.375 3.50368 6.87868 3 7.5 3C8.12132 3 8.625 3.50368 8.625 4.125Z"
											fill="#FAFAFA"
										/>
									</svg>
									{tooltip}
								</div>
							</div>
						)}
					</div>

					{/* Input */}
					<input
						type={type}
						id={name}
						name={name}
						placeholder={placeholder}
						{...field}
						className="
							rounded-lg 
							border 
							border-neutral-50 
							bg-transparent 
							px-3 
							py-2 
							text-neutral-50 
							placeholder-neutral-500 
							focus:border-white  
							focus:outline-none
							focus:ring-0
							focus:ring-offset-0
						"
					/>
				</div>
			)}
		</Field>
	);
};

export default FormikStyledField;
